// Require Editor JS files.
import 'froala-editor/js/froala_editor.pkgd.min.js';

// Require Editor CSS files.
import 'froala-editor/css/froala_style.min.css';
import 'froala-editor/css/froala_editor.pkgd.min.css';
import FroalaEditor from 'react-froala-wysiwyg';

// Require Font Awesome.
import 'font-awesome/css/font-awesome.css';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import $ from 'jquery';
import './FlashcardItem.css';
import { GRADIENT_DIRECTION } from '../enum/GradientDirections';
import FlashcardPage from "../model/FlashcardPage";

window.$ = $;

const FROALA_EDITOR_KEY = '5C4A3A5A3aG3C2A5A4C4E3C2D4F2G1tFOFSAGLUi1AVKd1SN==';

export class FlashcardText extends Component {
  static propTypes = {
    pageItem: PropTypes.object.isRequired,
    themeColor: PropTypes.string
  }

  static defaultProps = {
    themeColor: 'black',
    onLoadComplete: () => {}
  }

  componentDidMount(){
    const { onLoadComplete, pageItem } = this.props;
    onLoadComplete(pageItem);
  }

  render() {
    const { themeColor, pageItem,themeBackgroundColor, previewLayout } = this.props;
    return (
      <div  className={`flashcard-page-item ${pageItem.isVertical() ? 'fullscreen' : ''}`}
            style={{
              background: this.getTextItemBackground()
            }}>
        <FroalaEditor
            key={pageItem.pageItemId}
            tag='textarea'
            config={this.editorConfig(themeColor,themeBackgroundColor,previewLayout)}
            ref="pageItemEditor"
            model={pageItem.getHtmlContent()}/>     
      </div>
    )
  }

  editorConfig(themeColor,themeBackgroundColor,previewLayout) {
    const me = this;
    return {
      toolbarButtons: [],
      charCounterCount: false,
      key: FROALA_EDITOR_KEY,
      placeholderText: '',
      events: {
        'froalaEditor.initialized': function(e, editor) {
          if(!me.props.canEdit){
            editor.edit.off();
          }
          editor.toolbar.hide();
            var fontColor = (me.props.applyTheme) ? themeColor : 'black';
            if(previewLayout === "fixed") {
                if (me.props.pageItem.getItemContent() && me.props.pageItem.getItemContent().type === "question") {
                    fontColor = (me.props.applyTheme) ? themeBackgroundColor : 'black';
                } else if(me.props.pageItem.getItemContent() && me.props.pageItem.getItemContent().type === "option") {
                    fontColor = "black";
                } else {
                    fontColor = FlashcardPage.getFontColor(themeBackgroundColor,themeColor)
                }
            } else if(me.props.pageItem.getItemContent() && me.props.pageItem.getItemContent().type === "option") {
                fontColor = "black";
            }
            editor.$el.css('color', fontColor);
        }
      }
    }
  }

  getTextItemBackground(){
    const { pageItem } = this.props;
    var opacity = pageItem.getBackgroundOpacity() / 100;
    switch (pageItem.getBackgroundGradientDirection()) {
      case GRADIENT_DIRECTION.TOP_TO_BOTTOM:
          return `linear-gradient(to bottom, rgba(0,0,0,${opacity}), rgba(0,0,0,0))`;
      case GRADIENT_DIRECTION.BOTTOM_TO_TOP:
          return `linear-gradient(to top, rgba(0,0,0,${opacity}), rgba(0,0,0,0))`;
      case GRADIENT_DIRECTION.NONE:
      default:
          return `rgba(0, 0, 0, ${opacity})`;
    }
  }
}

export default FlashcardText
